import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { authServices } from '../authServices'
import { SetupPasswordDTO, SetupPasswordPayload } from '../authTypes'
import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { useUserAuthSession } from '@/hooks'
import { mapAxiosErrorToApiError } from '@/utils'

export const useSetupPassword = (
  options?: IOptionsUseMutation<SetupPasswordDTO>,
) => {
  const { t } = useTranslation()
  const { startSession } = useUserAuthSession()

  return useMutation<SetupPasswordDTO, ErrorDetail, SetupPasswordPayload>({
    mutationFn: authServices.setupPassword,
    onSuccess: async (data: SetupPasswordDTO) => {
      // Save auth tokens
      await startSession({
        token: data.access_token,
        refreshToken: data.refresh_token,
      })

      if (options?.onSuccess) {
        options?.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.ACTION_IS_NOT_ALLOWED) {
        errorMessage = t('api:yourAccountIsDeleted')
      }

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })
}
